var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAttachFile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#102a56",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "m20.648 10.616-8.762 8.762a5 5 0 0 1-7.072-7.071l8.132-8.132a3.5 3.5 0 1 1 4.95 4.95l-7.794 7.793a2 2 0 1 1-2.828-2.828l7.194-7.194"
})));
export default SvgAttachFile;